/**
 * Created by Simon Zhao on 7/19/2021.
 * Description:
 * Provide new sources of MDL template actions to reduce state based on external interactions.
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, forkJoin, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { MdlTemplateService } from '../../tamalelibs/services/mdl-template.service';
import { CreateOrUpdate, MDLTemplateActionTypes } from '../actions/mdl-template.actions';

@Injectable()
export class MDLTemplateEffects {

    constructor(
        private _actions$: Actions,
        private _mdlTemplateService: MdlTemplateService
    ) { }

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(MDLTemplateActionTypes.INITIALIZE),
        switchMap(() => {
            return this._mdlTemplateService.getMDLTemplates().pipe(
                map((response: any) => {
                    return {
                        type: MDLTemplateActionTypes.INITIALIZE_SUCCESS,
                        payload: response
                    };
                })
            );
        })
    ));

    createEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(MDLTemplateActionTypes.CREATE_OR_UPDATE),
        switchMap((action: CreateOrUpdate) => {
            return this._mdlTemplateService.saveOrUpdateMDLTemplate(action.typeId, action.payload)
                .pipe(
                    map((response: any) => {
                        return {
                            type: MDLTemplateActionTypes.CREATE_OR_UPDATE_SUCCESS,
                            payload: {
                                typeName: action.typeName,
                                typeId: action.typeId,
                                mdl: action.payload
                            }
                        };
                    }, catchError(err => {
                        return of({
                            type: MDLTemplateActionTypes.CREATE_OR_UPDATE_FAILED,
                            payload: {
                                typeId: action.typeId,
                                errorMsg: err.message
                            }
                        });
                    })
                    )
                );
        }
        )));
}
